import React, { useState } from 'react';
import './References.css';

function References() {
  const [selectedCategory, setSelectedCategory] = useState('customers');

  const referenceCategories = {
    customers: {
      title: 'Müşteri Referansları',
      icon: '👥',
      references: [
        {
          company: 'ABC Teknoloji A.Ş.',
          industry: 'Teknoloji',
          logo: '🏢',
          testimonial: 'Enerji Takip sayesinde enerji maliyetlerimizi %30 azalttık. Harika bir çözüm!',
          savings: '%30 Tasarruf',
          contact: 'Ahmet Yılmaz - CTO',
          image: '👨‍💼'
        },
        {
          company: 'XYZ Fabrikası',
          industry: 'Üretim',
          logo: '🏭',
          testimonial: 'Üretim süreçlerimizdeki enerji verimliliğini artırdık. Kesinlikle tavsiye ederim.',
          savings: '%25 Tasarruf',
          contact: 'Fatma Demir - Genel Müdür',
          image: '👩‍💼'
        },
        {
          company: 'Green Office Plaza',
          industry: 'Ofis',
          logo: '🏢',
          testimonial: 'Ofis binamızda akıllı enerji yönetimi ile çevre dostu bir işletme haline geldik.',
          savings: '%20 Tasarruf',
          contact: 'Mehmet Kaya - İşletme Müdürü',
          image: '👨‍💼'
        }
      ]
    },
    'case-studies': {
      title: 'Vaka Çalışmaları',
      icon: '📊',
      references: [
        {
          company: 'Büyük Ölçekli Fabrika Dönüşümü',
          industry: 'Üretim',
          logo: '🏭',
          testimonial: '50,000 m² fabrikamızda tam entegrasyon ile %40 enerji tasarrufu sağladık.',
          savings: '%40 Tasarruf',
          contact: 'Detaylı Rapor İndir',
          image: '📈',
          details: '6 aylık dönüşüm projesi, 200+ sensör entegrasyonu'
        },
        {
          company: 'Akıllı Şehir Pilot Projesi',
          industry: 'Belediye',
          logo: '🏛️',
          testimonial: 'Şehir genelinde akıllı aydınlatma sistemi ile %35 enerji tasarrufu.',
          savings: '%35 Tasarruf',
          contact: 'Proje Detayları',
          image: '🌆',
          details: '10,000 sokak lambası, IoT sensör ağı'
        },
        {
          company: 'Eğitim Kampüsü Modernizasyonu',
          industry: 'Eğitim',
          logo: '🎓',
          testimonial: 'Üniversite kampüsümüzde sürdürülebilir enerji yönetimi uyguladık.',
          savings: '%28 Tasarruf',
          contact: 'Kampüs Raporu',
          image: '📚',
          details: '25 binada akıllı enerji sistemi, öğrenci farkındalığı'
        }
      ]
    },
    awards: {
      title: 'Ödüller ve Sertifikalar',
      icon: '🏆',
      references: [
        {
          company: 'Yeşil Teknoloji Ödülü 2024',
          industry: 'Çevre',
          logo: '🌱',
          testimonial: 'Sürdürülebilir enerji çözümleri kategorisinde birinci olduk.',
          savings: '1. Ödül',
          contact: 'T.C. Enerji Bakanlığı',
          image: '🥇'
        },
        {
          company: 'İnovasyon Ödülü',
          industry: 'Teknoloji',
          logo: '💡',
          testimonial: 'IoT tabanlı enerji yönetimi çözümümüz ödüle layık görüldü.',
          savings: 'İnovasyon',
          contact: 'TÜBİTAK',
          image: '🏆'
        },
        {
          company: 'ISO 50001 Sertifikası',
          industry: 'Kalite',
          logo: '📜',
          testimonial: 'Enerji yönetim sistemi kalite standardımız onaylandı.',
          savings: 'ISO 50001',
          contact: 'TSE',
          image: '✅'
        }
      ]
    },
    partnerships: {
      title: 'İş Ortaklıkları',
      icon: '🤝',
      references: [
        {
          company: 'TEDAŞ',
          industry: 'Enerji Dağıtımı',
          logo: '⚡',
          testimonial: 'Türkiye genelinde akıllı şebeke projelerinde stratejik ortaklık.',
          savings: 'Stratejik Ortak',
          contact: 'Teknoloji Müdürlüğü',
          image: '🏛️'
        },
        {
          company: 'Schneider Electric',
          industry: 'Teknoloji',
          logo: '🔧',
          testimonial: 'Endüstriyel enerji yönetimi çözümlerinde teknoloji partneri.',
          savings: 'Teknoloji Ortağı',
          contact: 'Türkiye Operasyonları',
          image: '🌍'
        },
        {
          company: 'İTÜ Enerji Enstitüsü',
          industry: 'Araştırma',
          logo: '🎓',
          testimonial: 'Akademik araştırma ve geliştirme projelerinde işbirliği.',
          savings: 'AR-GE Ortağı',
          contact: 'Enerji Enstitüsü',
          image: '🔬'
        }
      ]
    }
  };

  return (
    <div className="references">
      <div className="references-header">
        <h1>🌟 Referanslar</h1>
        <p>Başarılı projelerimiz ve mutlu müşterilerimiz</p>
      </div>

      <div className="references-content">
        <div className="category-selector">
          {Object.entries(referenceCategories).map(([key, category]) => (
            <button
              key={key}
              className={`category-button ${selectedCategory === key ? 'active' : ''}`}
              onClick={() => setSelectedCategory(key)}
            >
              <span className="category-icon">{category.icon}</span>
              <span className="category-title">{category.title}</span>
            </button>
          ))}
        </div>

        <div className="references-section">
          <div className="section-header">
            <span className="section-icon">{referenceCategories[selectedCategory].icon}</span>
            <h2>{referenceCategories[selectedCategory].title}</h2>
            <p>Bu kategoride {referenceCategories[selectedCategory].references.length} referans bulunmaktadır</p>
          </div>

          <div className="references-grid">
            {referenceCategories[selectedCategory].references.map((reference, index) => (
              <div key={index} className="reference-card">
                <div className="reference-header">
                  <div className="company-logo">{reference.logo}</div>
                  <div className="company-info">
                    <h3>{reference.company}</h3>
                    <p className="industry">{reference.industry}</p>
                  </div>
                  <div className="savings-badge">
                    {reference.savings}
                  </div>
                </div>

                <div className="testimonial">
                  <p>"{reference.testimonial}"</p>
                </div>

                <div className="reference-details">
                  <div className="contact-info">
                    <span className="contact-label">İletişim:</span>
                    <span className="contact-name">{reference.contact}</span>
                  </div>
                  {reference.details && (
                    <div className="project-details">
                      <span className="details-label">Proje Detayları:</span>
                      <span className="details-text">{reference.details}</span>
                    </div>
                  )}
                </div>

                <div className="reference-actions">
                  <button className="action-button primary">
                    📞 İletişime Geç
                  </button>
                  <button className="action-button secondary">
                    📄 Detaylı Bilgi
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="stats-section">
          <h3>📈 Başarı Rakamlarımız</h3>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">500+</div>
              <div className="stat-label">Tamamlanan Proje</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">%35</div>
              <div className="stat-label">Ortalama Tasarruf</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">50+</div>
              <div className="stat-label">Şehir</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Mutlu Müşteri</div>
            </div>
          </div>
        </div>

        <div className="cta-section">
          <h3>🚀 Siz de Başarı Hikayemizin Parçası Olun!</h3>
          <p>Enerji Takip ile kendi başarı hikayenizi yazın. Ücretsiz danışmanlık için bizimle iletişime geçin.</p>
          <div className="cta-buttons">
            <button className="cta-button primary">
              📞 Ücretsiz Danışmanlık
            </button>
            <button className="cta-button secondary">
              📧 Teklif İste
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default References;
